import React from 'react';

const ViewContext = React.createContext();
export default ViewContext;
